module.exports = __webpack_public_path__ + "img/register_01.d2d7ed00.png";